<template>
  <div class="grid_gallery">
    <div v-for="item in gridItems" :key="item.id" :class="item.cls" class="g-item" :style="`background-image: url(${item.url})`" @click="fullImage(item)"></div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'gridGallery',
  methods:{
    ...mapMutations(['bindGridItems']),
    ...mapActions(['fullImage'])
  },
  computed:{
    ...mapState({
      gridItems: state => state.gridGallery.gridGallery
    })
  },
  mounted(){
    this.bindGridItems();
  }
}
</script>

<style scoped lang="scss">
.grid_gallery{
    display: grid;
    grid-gap: 12px;
    grid-template-columns: repeat(8, 1fr);
    grid-template-rows: repeat(4, 1fr);
    grid-template-areas: 
    "item1 item3 item3 item5 item5 item5 item6 item8" 
    "item1 item3 item3 item5 item5 item5 item6 item8" 
    "item2 item3 item3 item5 item5 item5 item7 item8"
    "item2 item4 item4 item5 item5 item5 item7 item8";
    width: 100%;
    height: 600px;
    padding: 0 100px;
    div{
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
}
.grid_item1{
    grid-area: item1;
}
.grid_item2{
    grid-area: item2;
}
.grid_item3{
    grid-area: item3;
}
.grid_item4{
    grid-area: item4;
}
.grid_item5{
    grid-area: item5;
}
.grid_item6{
    grid-area: item6;
}
.grid_item7{
    grid-area: item7;
}
.grid_item8{
    grid-area: item8;
}
.g-item{
    cursor: pointer;
}
</style>